import Constants from '../Constants';

export default {
  getCustomerSegmentData: (state) => {
    if (state.rfm_counts.customer_segments) {
      const data = [
        ['Segment', 'Customers'],
      ];

      Object.keys(state.rfm_counts.customer_segments).forEach((item) => {
        data.push([item, state.rfm_counts.customer_segments[item]]);
      });

      return data;
    }
    return [];
  },

  getRFMData: state => (key, title) => {
    if (state.rfm_counts[key]) {
      const data = [
        [title, 'Customers', { role: 'style' }],
      ];

      Object.keys(state.rfm_counts[key]).forEach((item, index) => {
        data.push([Constants.rfm[item], state.rfm_counts[key][item], Constants.colors[index]]);
      });

      return data;
    }
    return [];
  },
};
